export default "__VITE_ASSET__DYh9Rpwi__"